import { render, staticRenderFns } from "./Github.vue?vue&type=template&id=17f1a919&scoped=true"
import script from "./Github.vue?vue&type=script&lang=js"
export * from "./Github.vue?vue&type=script&lang=js"
import style0 from "./Github.vue?vue&type=style&index=0&id=17f1a919&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f1a919",
  null
  
)

export default component.exports